<script>
import 'bulma/css/bulma.css'
import Header from '@/components/globals/header/Header'
import TreeBar from '@/components/globals/treebar/TreeBar'
import TeamBar from '@/components/globals/teambar/TeamBar'
import NotifiedBar from '@/components/globals/notifiedbar/NotifiedBar'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth } from 'firebase/auth'
const auth = getAuth(firebaseApp)

export default {
  components: { Header, TreeBar, NotifiedBar, TeamBar },
  name: 'App',
  props: [
  ],
  data () {
    return {
      hasNotifiedBar: false,
      hasTreeBar: true,
      hasTeamBar: false,
      notificationData: [],
      isAnonymous: true,
      teamIdForBoard: null,
      isInit: false,
      boardcards: []
    }
  },
  async created () {
    const user = auth.currentUser
    this.isAnonymous = user ? user.isAnonymous : true
  },
  methods: {
    showNotifiedBar (data, columnFlag) {
      this.notificationData = data
      this.hasNotifiedBar = columnFlag
    },
    cancelNotifiedBar (columnFlag) {
      this.hasNotifiedBar = columnFlag
    },
    cancelTreeBar (columnFlag) {
      this.hasTreeBar = columnFlag
    },
    cancelTeamBar (columnFlag) {
      this.hasTeamBar = columnFlag
    },
    changeBar (state) {
      this.hasNotifiedBar = false
      this.hasTreeBar = false
      this.hasTeamBar = false
      if (state === 'notification') {
        this.hasNotifiedBar = true
      } else if (state === 'tree') {
        this.hasTreeBar = true
      } else {
        this.hasTeamBar = true
      }
    },
    showBoard (teamId) {
      this.teamIdForBoard = teamId
      this.boardcards.splice()
    },
    sendBoardCard (data) {
      this.boardcards = data
    },
    initSetup (flag) {
      this.isInit = flag
    }
  },
  watch: {
    async $route (to, from) {
      // path変更時にはauthを再取得する
      if (from.name !== to.name) {
        const user = auth.currentUser
        this.isAnonymous = user ? user.isAnonymous : true
      }
    }
  }
}
</script>

<template>
  <div id="app">
    <Header
     :hasNotifiedBar = "hasNotifiedBar"
     :teamIdForBoard = "teamIdForBoard"
     @showNotifiedBar = "showNotifiedBar"
     @sendBoardCard = "sendBoardCard"
    />
    <div class="main-content columns">
      <!-- 通知・ツリー・チームのボタンでサイドバーを選択 -->
      <div class="column is-1 is-paddingless is-hidden-mobile" v-if="!isAnonymous">
        <div class="side-menu is-padding-menu">
          <a class="button add-button-margin" v-bind:class="{'is-light': hasNotifiedBar, 'is-white': !hasNotifiedBar}" @click="changeBar('notification')">
            <span class="icon">
              <i class="fa-solid fa-bell"></i>
            </span>
          </a>
          <a class="button add-button-margin" v-bind:class="{'is-light': hasTreeBar, 'is-white': !hasTreeBar}" @click="changeBar('tree')">
            <span class="icon">
              <i class="fa-solid fa-sitemap"></i>
            </span>
          </a>
          <a class="button add-button-margin" v-bind:class="{'is-light': hasTeamBar, 'is-white': !hasTeamBar}" @click="changeBar('team')">
            <span class="icon">
              <i class="fa-solid fa-users-cog"></i>
            </span>
          </a>
        </div>
      </div>
      <!-- サイドバー描画(通知, ツリー, チームの条件選択) -->
      <div class="column is-one-fifth is-paddingless is-hidden-mobile"
      v-if="!isAnonymous && (hasNotifiedBar || hasTreeBar || hasTeamBar)">
        <div class="side-bar is-padding-bar">
          <NotifiedBar v-if="hasNotifiedBar"
          :notificationData = "notificationData"
          @cancelNotifiedBar = "cancelNotifiedBar"
          />
          <!--ツリーBar-->
          <TreeBar v-if="hasTreeBar"
          :isInit="isInit"
          @cancelTreeBar = "cancelTreeBar"
          />
          <!--チームBar-->
          <TeamBar v-if="hasTeamBar"
          @cancelTeamBar = "cancelTeamBar"
          />
        </div>
      </div>
      <!-- routerで定義されたvue componentの描画 -->
      <div class="column is-paddingless">
        <div class="router-view is-padding-router">
        <!-- vue-routerの制約でキャメルケースはNG -->
          <router-view
            :boardcards = "boardcards"
            @showBoard = "showBoard"
            @isInitSetup = "initSetup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.is-padding-menu {
  padding-top: 0.35rem;
  padding-bottom: 0.0rem;
  padding-left: 0.0rem;
  padding-right:0.25rem;
  border-right: 1.0px solid rgba(200, 200, 200, 0.5);
}
.is-padding-bar {
  padding-top: 0.35rem;
  padding-bottom: 0.0rem;
  padding-left: 0.5rem;
  padding-right:0.5rem;
}
.is-padding-router {
  padding-top: 0.35rem;
  padding-bottom: 0.0rem;
  padding-left: 0.5rem;
  padding-right:0.5rem;
  border-left: 1.0px solid rgba(200, 200, 200, 0.5);
  border-right: 1.0px solid rgba(200, 200, 200, 0.5);
}
.side-menu {
  background-color: #fafafa;
  height: 95vh;
}
.side-bar {
  background-color: #fafafa;
  height: 95vh;
}
.router-view {
  height: 95vh;
}
.button.is-light {
  background-color: #dbdbdb;
}
.add-button-margin {
  margin-bottom: 0.25rem;
}
.columns {
  margin-top: -1.0rem;
  margin-left: -1.0rem;
}
.column {
  overflow: auto;
  max-height: 95vh;
}
.column.is-1, .column.is-1-tablet {
  width: min-content !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue